export const PackageName_TsFocusedObject = 'ts-focused-object';
export * from './api-def.js';
export * from './types.js';
//# sourceMappingURL=index.js.map